import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Card, Row, Col, Form, Table, Button, Modal, ButtonGroup, Tabs, Tab, } from 'react-bootstrap';
import { BiListOl, BiRefresh, BiDownload} from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import './AsesmenGizi.css';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';


const AsesmenGizi = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isDewasa, setDewasa] = useState();
    const [selectedAsesmenGizi, setselectedAsesmenGizi] = useState();
    const [showDeskripsi, setshowDeskripsi] = useState();
    const [listAlergiMakanan, setlistAlergiMakanan] = useState();
    const [listRisikoKids, setlistRisikoKids] = useState();
    const [listRisikoDewasa, setListRisikoDewasa] = useState();
    const [listMonitoring, setListMonitoring] = useState();
    const [listAsesmenVerif,setListAsesmenVerif]=useState([]);
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true);
        let dataVerif = [], dataUnVerif = [];
        try {
            const promise1 = VedikaService.getAsesmenGizi(`noregistrasifk=${$('#noRegistrasi').text()}`);
            const allPromise = await Promise.all([promise1]);
            if(allPromise[0].data.data.length==0){
                throw new Error('Maaf, Tidak ada data');
            }
            allPromise[0].data.data.forEach(element => {
                element.isverifikasi ? dataVerif = [...dataVerif, element] : dataUnVerif = [...dataUnVerif, element]
            });
            setListAsesmenVerif(dataVerif)
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }

    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        setselectedAsesmenGizi(row)
    }

    const loadDtAsesmenVerif = () => {
        $('#dtAsesmenVerif').DataTable({
            data: listAsesmenVerif,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup>),
                },
                {
                    targets: [1],
                    data: 'tglinput',
                },
                {
                    targets: [2],
                    data: 'namalengkap',
                },
                {
                    targets: [3],
                    data: 'pegawaiasal',
                },
                {
                    targets: [4],
                    data: 'namaruangan',
                },
                {
                    targets: [5],
                    data: 'status',
                },
            ]
        })
    }
    const loadDtAsesmenUnVerif = (res) => {
        $('#dtAsesmenUnVerif').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup>),
                },
                {
                    targets: [1],
                    data: 'tglinput',
                },
                {
                    targets: [3],
                    data: 'pegawaiasal',
                },
                {
                    targets: [4],
                    data: 'namaruangan',
                },
                {
                    targets: [5],
                    data: 'noregistrasi',
                },
            ]
        })
    }

    useEffect(()=>{
        if(listAsesmenVerif.length>0){
            loadDtAsesmenVerif();
        }
    },[listAsesmenVerif])
    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
        $('#umur').val() > 17 ? setDewasa(true) : setDewasa(false)
        setlistRisikoKids(
            [
                {
                    id: 122,
                    name: 'Risiko Ringan (Nilai Strong Kids 0)'
                },
                {
                    id: 222,
                    name: 'Risiko Sedang (Nilai Strong Kids 1 - 3)'
                },
                {
                    id: 322,
                    name: 'Risiko Tinggi (Nilai Strong Kids 4 - 5)'
                }
            ]
        )
        setListRisikoDewasa(
            [{
                id: 11,
                name: 'Risiko Ringan (Nilai MST 0)'
            },
            {
                id: 12,
                name: 'Risiko Sedang (Nilai MST 1 - 3)'
            },
            {
                id: 13,
                name: 'Risiko Tinggi (Nilai MST 4 - 5)'
            }
            ]
        )
        setlistAlergiMakanan(
            [
                {
                    name: 'Telur',
                    key: 'telur',
                    id: 1,
                },
                {
                    name: 'Susu sapi & produk olahannya',
                    key: 'susu',
                    id: 2,
                },
                {
                    name: 'Kacang kedelai / Tanah',
                    key: 'kacang',
                    id: 3
                },
                {
                    name: 'Gluten / Gandum',
                    key: 'gluten',
                    id: 4
                },
                {
                    name: 'Udang',
                    key: 'udang',
                    id: 5
                },
                {
                    name: 'Ikan',
                    key: 'ikan',
                    id: 6
                },
                {
                    name: 'Hazelnut / Almond',
                    key: 'almond',
                    id: 7
                },
            ]
        )
        setListMonitoring(
            [
                {
                    id:1,
                    name:"Pasien dipantau oleh dietisien"
                },
                {
                    id:2,
                    name:"Mohon dikonsulkan untuk rawat bersama dengan Sp.A(K) & Penyakit Metabolik / Sp.GK karena"
                },
                {
                    id:3,
                    name:"Nutrisi Parental"
                },
                {
                    id:4,
                    name:"Lainnya"
                },
            ]
        )
    }, [])
    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Asesmen Gizi</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/gizi/${$('#norec').val()}`} style={{ textDecoration: 'none',color:'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    {/* <Tabs
                        defaultActiveKey="AsesmenVerif"
                        id="uncontrolled-tab-example"
                        fill
                    >
                        <Tab eventKey="AsesmenVerif" title="Verifikasi"> */}
                            <Table responsive="sm" size="sm" id='dtAsesmenVerif' bordered hover style={{ fontSize: 'smaller' }}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Tanggal/Jam</th>
                                        <th>Dokter Verifikator</th>
                                        <th>Ahli Gizi</th>
                                        <th>Ruangan</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                            </Table>
                        {/* </Tab>
                        <Tab eventKey="AsesmenUnVerif" title="Unverif">
                            <Table responsive="sm" size="sm" id='dtAsesmenUnVerif' bordered hover style={{ fontSize: 'smaller' }}>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Tanggal/Jam</th>
                                        <th>Ahli Gizi</th>
                                        <th>Ruangan</th>
                                        <th>No Registrasi</th>
                                    </tr>
                                </thead>
                            </Table>
                        </Tab>
                    </Tabs> */}
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header>Asesmen Gizi Awal</Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={12}><h4 className='f7'><strong>Diagnosa Medis</strong></h4></Col>
                                        <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{
                                            selectedAsesmenGizi ? selectedAsesmenGizi.diagnosa:null
                                        }</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={12}><h4 className='f7'><strong>1. Risiko malnutrisi berdasarkan hasil skrining gizi oleh perawat. kondisi pasien termasuk:</strong></h4></Col>
                                        <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{
                                            isDewasa ?
                                            (
                                                listRisikoDewasa ? listRisikoDewasa.map((e) => (
                                                    selectedAsesmenGizi ? selectedAsesmenGizi.risiko_malutrisi == e.name ? <Form.Check inline label={e.name} name="risiko_malutrisi" type="radio" checked disabled id={`inline-${e.id}-1`} /> :
                                                        <Form.Check inline label={e.name} name="risiko_malutrisi" type="radio" disabled id={`inline-${e.id}-1`} /> : null
                                                )) : null
                                            ) :
                                            (
                                                listRisikoKids ? listRisikoKids.map((e) => (
                                                    selectedAsesmenGizi ? selectedAsesmenGizi.risiko_malutrisi == e.name ? <Form.Check inline label={e.name} name="risiko_malutrisi" type="radio" checked disabled id={`inline-${e.id}-1`} /> :
                                                        <Form.Check inline label={e.name} name="risiko_malutrisi" type="radio" disabled id={`inline-${e.id}-1`} /> : null
                                                )) : null
                                            )
                                        }</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={12}><h4 className='f7'><strong>2. Pasien mempunyai kondisi khusus</strong></h4></Col>
                                        <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.kondisi_khusus : ''}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={12}><h4 className='f7'><strong>3. Alergi Makanan</strong></h4></Col>
                                        <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ?
                                            (
                                                <div key={`inline-alergimakanan`} className="mb-3">
                                                    {
                                                        listAlergiMakanan.map((e) => (
                                                            selectedAsesmenGizi.alergi_1 != "Tidak" && e.id == 1 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />,
                                                            selectedAsesmenGizi.alergi_2 != "Tidak" && e.id == 2 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />,
                                                            selectedAsesmenGizi.alergi_3 != "Tidak" && e.id == 3 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />,
                                                            selectedAsesmenGizi.alergi_4 != "Tidak" && e.id == 4 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />,
                                                            selectedAsesmenGizi.alergi_5 != "Tidak" && e.id == 5 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />,
                                                            selectedAsesmenGizi.alergi_6 != "Tidak" && e.id == 6 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />,
                                                            selectedAsesmenGizi.alergi_7 != "Tidak" && e.id == 7 ?
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" checked disabled id={`inline-${e.key}-1`} /> :
                                                                <Form.Check inline label={e.name} name="alergimakanan" type="checkbox" disabled id={`inline-${e.key}-1`} />
                                                        ))
                                                    }
                                                </div>
                                            )
                                            : ''}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={12}><h4 className='f7'><strong>4. Dreskripsi Diet</strong></h4></Col>
                                        <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.diet != 'Makan Biasa' ? <>Makan Khusus: {selectedAsesmenGizi.diet}</> : <>Makan Biasa</> : null}</p></Col>
                                    </Row>
                                    <hr className="hr" />
                                    <Row>
                                        <Col md={12}><h4 className='f7'><strong>5. Tindak Lanjut</strong></h4></Col>
                                        <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.tindak_lanjut : ''}</p></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={12} className='pt-2'>
                            <Card>
                                <Card.Header>Asesmen Gizi Lanjut</Card.Header>
                                <Card.Body>
                                    <h4 className='f7'><strong>Antropometri:</strong></h4>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Umur</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.umur : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>BB</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.antro_bb : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>TB / U</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.antro_tb_u : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>TB</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.antro_tb : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>LILA</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.lila : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Status Gizi</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.antro_status_gizi : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>BB / TB</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.imt : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Index Masa Tubuh</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.antro_bb_tb : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>LILA / U</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.lila_u : ''}</p></Col>
                                            </Row>
                                            <hr className="hr" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6} md={6}>
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Biokimia</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.biokimia : ''}</p></Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} md={6}>
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Klinis / Fisik</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.klinis_fisik : ''}</p></Col>
                                            </Row>
                                        </Col>
                                        <hr className="hr" />
                                        <Col xs={6} md={6}>
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Riwayat Diet</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.riwayat_diet : ''}</p></Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} md={6}>
                                            <Row>
                                                <Col md={12}><h4 className='f7'><strong>Riwayat Personal</strong></h4></Col>
                                                <Col md={12}><p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.riwayat_personal : ''}</p></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={12} className='pt-2'>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col md={6}>
                                            <h4 className='f7'><strong>Diagnosis Gizi</strong></h4>
                                            <p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.diagnosis_gizi: ''}</p>
                                        </Col>
                                        <Col md={6}>
                                            <h4 className='f7'><strong>Intervensi Gizi</strong></h4>
                                            <p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.intervensi_gizi: ''}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={12} className='pt-2'>
                            <Card>
                                <Card.Header>Monitoring Evaluasi</Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={6}><p style={{ marginBottom: '0px' }} className='f7'>
                                                    {
                                                        listMonitoring ? (
                                                            listMonitoring.map((e)=>(
                                                                selectedAsesmenGizi ? selectedAsesmenGizi.monitoring==e.name ? <Form.Check inline label={e.name} name="monitoring" type="radio" checked disabled id={`inline-${e.id}-1`} /> :
                                                                <Form.Check inline label={e.name} name="monitoring" type="radio" disabled id={`inline-${e.id}-1`} /> : null
                                                            ))
                                                        ) : null
                                                    }
                                        </p></Col>
                                        <Col md={6}>
                                            <h4 className='f7'><strong>Keterangan</strong></h4>
                                        <p style={{ marginBottom: '0px' }} className='f7'>{selectedAsesmenGizi ? selectedAsesmenGizi.monitoring_ket: ''}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default AsesmenGizi;